import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CONSTANTES } from "../shared/global";
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  url: string;

  constructor(private http: HttpClient, private router: Router) {
    this.url = CONSTANTES.api_url + "/users";
  }

  authenticate(datos: object) {
    return this.http.post<any>(this.url + "/login", datos);
  }

  logOut(datos: object) {
    localStorage.clear();
    this.router.navigate(['login']);
    return this.http.post<any>(this.url + "/logout", datos);
  }

  isUserLoggedIn() {
    const user = localStorage.getItem("token");
    return !(user === null);
  }

  async rolIsOkey(): Promise<boolean> {
    const role = localStorage.getItem("role");
    const roles = localStorage.getItem("roles");
    const nid = localStorage.getItem("nid");
  
    try {
      const response = await this.http.get<any>(`${this.url}/checkRole`, {
        params: {
          role: role,
          roles: roles,
          nid: nid
        },
        headers: new HttpHeaders().set('Content-Type', 'application/json')
      }).toPromise();
  
      if (response === false) {
        console.log("No tienes permisos para acceder a esta página");
        return false;
      } else {
        console.log("Tienes permisos para acceder a esta página");
        return true;
      }
    } catch (error) {
      console.error("Error al verificar el rol:", error);
      return false;
    }
  }
}
